import { ArrowUpRight } from 'lucide-react';
import { RefObject, useRef } from 'react';

import { clsx } from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import { useOnClickOutside } from 'usehooks-ts';

import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';
import { Accordion, AccordionContent, AccordionHeader } from '@shared/ui/Accordion';
import { getViewPort } from '@shared/ui/ScreenSizeTracking';
import { removePadding } from '@shared/utils/scrollHelpers/scrollHelpers';
import { categories, subCategories } from '@widgets/CategoriesMenu/model/data/data';
import { closeCategoriesModal } from '@widgets/CategoriesMenu/model/slice/categoriesModalSlice';

import cls from './CategoriesMobile.module.scss';

type CategoriesMobileProps = {
  buttonRef?: RefObject<HTMLElement>;
};

export const CategoriesMobile = ({ buttonRef }: CategoriesMobileProps) => {
  const dispatch = useAppDispatch();
  const ref = useRef<HTMLDivElement>(null);
  const hideSearch = useAppSelector((state) => state.header.hideSearch);
  const viewPort = useAppSelector(getViewPort);

  const onCloseModal = () => {
    if (viewPort === 'desktop') return;
    dispatch(closeCategoriesModal());
    removePadding();
  };

  const mods: Record<string, string | boolean | undefined> = {
    [cls.hideSearch]: hideSearch
  };

  useOnClickOutside([ref, buttonRef!], onCloseModal);

  return (
    <div
      ref={ref}
      data-testid="categories-mobile"
      className={clsx(cls.wrapper, mods)}
    >
      {categories.map((el) => (
        <Accordion
          className={cls.accordion}
          key={el.value}
        >
          <AccordionHeader>
            <div
              key={el.url}
              className={clsx(cls.link)}
            >
              <span className={cls.icon}>
                <Image
                  className={cls.default}
                  src={el.iconDefault}
                  fill
                  alt={''}
                />
              </span>

              <span> {el.label}</span>
            </div>
          </AccordionHeader>
          <AccordionContent>
            <div className={cls.links}>
              <Link
                data-testid={'category-menu-link-mobile'}
                href={el.url}
                onClick={onCloseModal}
                className={cls.sublink}
              >
                <span className={cls.subicon}>
                  <ArrowUpRight size={32} />
                </span>
                Все {el.label.toLowerCase()}
              </Link>
              {subCategories[el.value].map((item, index) => (
                <Link
                  key={index}
                  href={item.url}
                  onClick={onCloseModal}
                  className={cls.sublink}
                >
                  <span className={cls.subicon}>
                    <Image
                      className={cls.default}
                      src={item.iconDefault}
                      fill
                      alt={''}
                    />
                  </span>
                  {item.label}
                </Link>
              ))}
            </div>
          </AccordionContent>
        </Accordion>
      ))}
    </div>
  );
};
